import { render, staticRenderFns } from "./Region2.vue?vue&type=template&id=02f87fa1&scoped=true&"
import script from "./Region2.vue?vue&type=script&lang=ts&"
export * from "./Region2.vue?vue&type=script&lang=ts&"
import style0 from "./Region2.vue?vue&type=style&index=0&id=02f87fa1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f87fa1",
  null
  
)

export default component.exports